/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

/**
 * @fileoverview Miscellaneous utility functions
 * Contains general-purpose utility functions used across the application
 * @module utils/misc
 */

/**
 * Opens a URL in a new browser window with specific dimensions and toolbar settings
 * @param {string} url - The URL to open in a new window
 * @returns {Window} The browser window object that was opened
 */
export const openLinkInNewWindow = (url) => {
  window.open(url, "_blank", "toolbar=0,location=0,menubar=0,width=1000,height=800");
};

/**
 * Converts a Blob object to a Base64 encoded string using FileReader
 * @param {Blob} blob - The Blob object to convert
 * @returns {Promise<string>} A Promise that resolves with the Base64 encoded string
 */
export const convertBlobToBase64 = (blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);

  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};
